<template>
  <div class="right_body_s" v-loading="isLoading">
    <Panel>
      <template v-slot:panel-top>
        <ToolBar
          class="infoActive_rumb"
          @edit="onEditTenant"
          @add="onAddTenant"
          @empower="onEmitTenantPerm"
          @openaccount="onOpenTenantAccountWindow"
          isAdd
          isEmpower
          isEdit          
          isOpenaccount>
        </ToolBar>
      </template>
      <template v-slot:panel-main>
        <FormGridPanel
          :tableColumns="columns"
          @EdTenantId="onEditTenantInfo"
          @EmTenantId="onOpenTenantPerm"
          @OpTenantId="openTenantAccount"
          ref="FormGridPanel">
        </FormGridPanel>
      </template>
    </Panel>
    <TenantMngNeWindow ref="tenantMngWindow" :show="showTenantMngWindow" 
                      :formData="tenantFormData"
                      @onCloseTenantWindow="onTenantMngWindow" 
                      @onSubmitTenant="onSubmitTenant"></TenantMngNeWindow>
    <DisplayTenantAccWindow ref="tenantAccountWindow"></DisplayTenantAccWindow>    
  </div>
</template>

<script>
import { resource } from "api/auth.js";
import vContent from "./ui/TenantMngFormPanel.vue";
import ToolBar from "components/btn/listBtn.vue";
import FormGridPanel from "./ui/TenFormGridPanel.vue";
import Panel from "components/container/BasePanel.vue";
import TenantMngNeWindow from './ui/TenantMngNeWindow.vue';
import DisplayTenantAccWindow from './ui/DisplayTenantAccWindow.vue'
import TenantManageService from "./service/TenantManage.service.js";

export default {
  components: { ToolBar, vContent, Panel, FormGridPanel,TenantMngNeWindow ,DisplayTenantAccWindow},
  data() {
    return {
      showTenantMngWindow:false,
      tenantFormData:{},
      columns: [
        { type: "radio", title: "选择", width: 60, fixed: "left" },
        { type: "seq", width: 80, title: "序号", fixed: "left" },
        {
          field: "tenantCode", 
          title: "租户编码",
          editRender: { name: "input" }
        },
        {
          field: "tenantDesc",
          title: "租户描述",
          editRender: { name: "input" }
        },
        {
          field: "legalPerson",
          title: "法定人",
          editRender: { name: "input" }
        },
        // 单元格渲染，自动读取字典配置
        {
          field: "companyEmail",
          title: "公司邮箱",
          editRender: { name: "input" }
        },
        // 单元格编辑渲染，自动读取字典配置
        {
          field: "identificationNum",
          title: "识别号",
          editRender: { name: "input" }
        },
        {
          field: "region",
          title: "区域",
          editRender: { name: "input" }
        },
        {
          field: "regStreet",
          title: "注册地",
          editRender: { name: "input" }
        },
        {
          field: "street",
          title: "街道",
          editRender: { name: "input" }
        },
        {
          field: "uscc",
          title: "社会信用代码",
          editRender: { name: "input" }
        },
        {
          field: "businessScope",
          title: "业务范围",
          editRender: { name: "input" }
        }

      ],
      isLoading: false,
      loadingBg: "rgba(255,255,255,1)",
      loadingTxt: "加载中",
      formData: {
        countryCode: "CN" //国家地区默认中国
      },
      title: ""
    };
  },
  created() {
    this.loadPlatTenantes();
  },
  updated: function() {},
  methods: {

    ...TenantManageService,

    /**
     * 触发编辑租户信息
     */
    onEditTenantInfo(data) {
      let vm=this;
      if(!data){
        vm.$message.error("请选择需要修改的租户信息！");
        return;
      }
      vm.findModifyTenant({ tenantId: data},function(result){
        vm.isLoading = false;
        debugger;
        if (result.status && result.data) {
           vm.modifyTenant(result.data);
        }else{
           vm.$message.error("租户信息加载异常，请重试！");
        }
      });      
    },
    /**
     * 提交租户新增或是修改信息
     */
    onSubmitTenant(tenantData){
      let vm=this;
       //提交新增租户
      if(!tenantData.tenantId){       
        vm.submitNewPlatTenant(tenantData,function(result){
          if (result.status) {
            vm.successNewPlatTenant(undefined,result.data);
          } else {
            vm.$message.error("操作失败，请重试！");
          }
        });
      }else{
        //修改租户
        vm.submitModifyPlatTenant(tenantData,function(result){
            if (result.status) {
              vm.successNewPlatTenant(tenantData.tenantId,result.data);
            } else {
              vm.$message.error("操作失败，请重试！");
            }
        });
      }      
    },
    /**
     * 新增租户成功
     */
    successNewPlatTenant(tenantId,data){
       let vm=this;
       if(!data){
         return;
       }       
       let message=tenantId? "租户 " +data.tenantDesc + "修改成功": "租户 " + data.tenantDesc + " 已添加成功";
       vm.$alert(message, "操作提示", {
          confirmButtonText: "确定",
          type: "success",
          callback: action => {
            vm.tenantFormData  = {};
            vm.$refs.FormGridPanel.getList();
            vm.showTenantMngWindow = false;
          }
       });
    },
    /**
     * 提价租户修改信息
     */
    onSubmitModifyInfo(){
      
    },
    /**
     * 修改租户
     */
    modifyTenant(modifyData){
      if(!modifyData){
        return;
      }
      let vm=this;      
      vm.title = "修改租户";
      vm.tenantFormData = modifyData;
      vm.showTenantMngWindow = true;
    },
    /**
     * 关闭租户维护窗口
     */
    onTenantMngWindow(show){
       let vm=this;
       vm.showTenantMngWindow = show;
    },
    /**
     * 开户账号
     */
    onOpenTenantAccountWindow() {
      this.$refs.FormGridPanel.onOpenaccount();
    },

     /**
     * 触发授权
     */
    onEmitTenantPerm() {
      this.$refs.FormGridPanel.onEmpower();
    },
    /**
     * 开租户权限
     */
    onOpenTenantPerm(tenantId) {
      let vm=this;
      if(!tenantId){
         vm.$message.error("请选择需要授权的租户信息！");
         return;
      }
      vm.findModifyTenant({tenantId: tenantId},function(result){
          if (result.status && result.data) {
             vm.$keepAliveManager.pushRouter(vm, {
                name: "platform-tenant-freezepage",
                params: {
                  tenantId: result.data.tenantId,
                  tenantCode: result.data.tenantCode,
                  tenantDesc: result.data.tenantDesc
                }
              });
          }else{
             vm.$message.error("操作失败，请重试！");
          }
      });
    },
    /**
     *开租户账号 
     */
    openTenantAccount(data) {
      let vm=this,tenantAccountWindow=this.$refs.tenantAccountWindow;
      if(!data||!data.tenantId){
        vm.$message.error("请选择需要开户账号的租户信息！");
        return;
      }
      debugger;
      let message="确定为租户  “ " + data.tenantId + "-" + data.tenantDesc + " ”  开户账号, 是否继续？";
      vm.$confirm(message, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
      }).then(async () => {
            vm.submitOpenTenantAccount({tenantId: data.tenantId},function(result){
                if (result.status && result.data) {
                  tenantAccountWindow.displayTenantInfo(result.data);
                } else {
                  vm.$message.error(result.msg);
                }    
            });
      }).catch(() => {

      });
    },    
    /**
     * 触发添加资源
     */
    onAddTenant() {
      let vm=this,tenantMngWindow= vm.$refs.tenantMngWindow;
      vm.showTenantMngWindow=true;      
    },
    /**
     * 编辑
     */
    onEditTenant() {
      this.$refs.FormGridPanel.onEditResource();
    }
  }
};
</script>
